import { useRachelStore } from '../store/rachel.store';
import { selectRachelDockedWidth } from '../store/rachel.store.selectors';
import { useIsRachelDocked } from './useIsRachelDocked';

export const useRachelDockedWidth = (): number | null => {
  const isDocked = useIsRachelDocked();
  const dockedWidth = useRachelStore(selectRachelDockedWidth);

  return isDocked ? dockedWidth : null;
};
